/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationCountriesCountryidLangsAvailableLanguages200,
  GetApiV1LocationCountriesCountryidLangsAvailableLanguages401,
  GetApiV1LocationCountriesCountryidLangsAvailableLanguages500,
  GetApiV1LocationCountriesCountryidLangsAvailableLanguagesPathParams,
  GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryResponse,
} from "../../types/locationCountryLangController/GetApiV1LocationCountriesCountryidLangsAvailableLanguages.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";

export const getApiV1LocationCountriesCountryidLangsAvailableLanguagesPathParamsSchema =
  z.object({
    countryId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsAvailableLanguagesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationCountriesCountryidLangsAvailableLanguages200Schema =
  z.array(
    z.lazy(() => dropDownListStringKeyViewModelSchema),
  ) as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsAvailableLanguages200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationCountriesCountryidLangsAvailableLanguages401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsAvailableLanguages401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationCountriesCountryidLangsAvailableLanguages500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsAvailableLanguages500>;

export const getApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryResponseSchema =
  z.lazy(
    () => getApiV1LocationCountriesCountryidLangsAvailableLanguages200Schema,
  ) as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryResponse>;
